module.exports = __webpack_public_path__ + "img/h12.39cfdd33.png";